import EzController from 'controllers/ez-base-controller';
import { insertAjaxContent } from 'lib/ajax-helpers';

export default class RelatedTagsController extends EzController {
  static values = {
    resourceId: String,
  }

  connect() {
    this.getRelatedTags();
  }

  getRelatedTags() {
    insertAjaxContent({
      url: `/resources/${this.resourceIdValue}/show_related_tags_async_content`,
      destElem: this.element,
      replaceContent: true,
    });
  }
}
